<template>
  <div class="dashboard-applications-list-container">
    <div class="heading">
      <div class="new-applications-title">New Applications</div>
      <!-- <div class="date">Today</div> -->
    </div>

    <div class="application-items-container">

      <div
        class="application-item"
        v-for="application in applicationsList"
        v-bind:key="application.id"
        @click="$emit('viewApplication', application.id)"
      >

        <div class="app-profile-image-container">
          <img v-if="application.profileImage" v-bind:src="application.profileImage" alt="Profile image" />
          <img v-else src="../assets/images/image-placeholder.png"  alt="A placeholder image"/>
        </div>

        <div class="applicants-info" v-if="application">
          <div class="user-name">
            {{ application.applicantInfo ? `${application.applicantInfo.firstName}  ${application.applicantInfo.lastName}` : application.id  }}
          </div>
          <div v-if="application.applicantInfo" class="user-role">{{application.applicantInfo.roleApplied}}</div>
        </div>

      </div>

    </div>

    <div class="see-all-link" @click="$emit('backToApplications', 'Applications')">View All</div>
  </div>
</template>

<script>
export default {
  name: 'DashboardApplicationsList',
  props:[
    'applicationsList'
  ],
};
</script>

<style scoped>
  .dashboard-applications-list-container {
    width:100%;
    height:100%;
    display:grid;
    grid-template-rows: 6.126rem auto 3.380rem;
  }

  .dashboard-applications-list-container .heading {
    border-bottom:1px solid rgba(196, 196, 196, 0.5);
    border-radius:15px 15px 0 0;
    display:flex;
    justify-content: space-between;
    align-items: center;
    /* width: calc(100% - 2.626rem); */
    padding: 0 1.313rem;
    height: 6.126rem;

  }
  .dashboard-applications-list-container .application-items-container {
    display: grid;
    }

  .application-items-container .application-item {
    border-bottom:1px solid rgba(196, 196, 196, 0.5);
    display:flex;
    align-items:center;
    padding: 1rem 0.2rem 1rem 1.313rem;
    cursor: pointer;
  }
  .application-items-container .application-item:hover {
    background-color: rgba(2, 95, 160, 0.34);
  }

  .app-profile-image-container {
    width:55px;
    height:55px;
    margin:5px 12px 5px 0;
  }

  .app-profile-image-container img {
    object-fit:cover;
    width:55px;
    height:55px;
    border-radius:100%;
  }

  .applicants-info .user-name {
    font-weight: 700;
    color: #252525;
    padding-bottom:5px;
  }

  .applicants-info .user-role {
    font-weight: 500;
    color: #828282;
    font-size: 0.75rem;
  }

  .applicants-info .user-name, .applicants-info .user-role {
    text-transform: capitalize;
    line-height: 1.6rem;
  }

  /* .application-item:last-child {
    border-bottom:none;
  } */

  .dashboard-applications-list-container .see-all-link {
    display:flex;
    align-items:center;
    justify-content:center;
    text-align:center;
    font-weight:bold;
    font-size:1rem;
    border-radius:0 0 15px 15px;
    text-decoration:underline;
    cursor: pointer;
    color:var(--colorPrimary);
  }

  /* .see-all-link a {
    color:var(--colorSecondary);
  } */

  .dashboard-applications-list-container .new-applications-title {
    font-weight:700;
    font-size:1.25rem;
    color: #333436;
  }

  .dashboard-applications-list-container .date {
    line-height:1.438rem;
    font-size:1.125rem;
    color: rgba(37, 37, 37, 0.7);
  }

  @media only screen and (max-width:1078px) {

  }

  @media only screen and (max-width:990px) {

  }

  @media only screen and (max-width: 767px) {

  }

  @media only screen and (max-width: 565px) {

  }

  @media only screen and (max-width: 420px) {

  }
</style>
